<template>
    <v-container>
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading"/>
        <timeline id="timeline" :chartData="chartData" v-if="!loading"/>
        <br/>
    </v-container>
</template>
<script>
import Timeline from './Timeline.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import orderBy from 'lodash.orderby';
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';

// get data for pms, leaders of the opposition, and format them correctly

const formatLeaders = (items, y) => {
    const data = orderBy(
        items
        .map(i => ({...i, PeriodOfService: i.PeriodOfService.map(p => ({...p, Parliamentarian: i.DisplayName, Phid: i.Phid}))}))
        .flatMap(i => i.PeriodOfService),
        [p => new Date(p.DateStart).valueOf()],
        ['desc']
        )
        .map(p => {
            return {
                name: p.Parliamentarian,
                color: p.PartyColour,
                phid: p.Phid,
                party: p.PartyName,
                x: new Date(p.DateStart).valueOf(),
                present: p.DateEnd === null,
                x2: p.DateEnd ? new Date(p.DateEnd).valueOf() : new Date().valueOf(),
                y,
                dataLabels: {
                    format: '<a class="timeline-label-parl" href="/Parliamentarian/{point.phid}"><img src="https://www.aph.gov.au/api/parliamentarian/{point.phid}/image" style="width: 20px;border-radius: 5px;"></img><div class="ml-1">{point.name}</div></a>',
                }
            }
        });
        // need to break up terms of service and get colour
        let newData = [];
        data.forEach(d => {
            // find parliamentarian
            // find party service
            const item = items.find(i => i.Phid === d.phid);
            // replace item with party service
            // if there is only one party service, don't worry about it - assign colour
            if (item.Party.length === 1) {
                d.color = item.Party[0].Colour;
                d.party = item.Party[0].Name
                newData.push(d);
            } else {
                // need to break record up into segments
                // for each party
                // find matching parties
                item.Party.filter(p => (new Date(p.DateStart).valueOf() < d.x2 && new Date(p.DateEnd).valueOf() > d.x)).forEach(p => {
                    // find fully matching segment
                    if (d.x >= new Date(p.DateStart).valueOf() && d.x2 <= new Date(p.DateEnd).valueOf() ) {
                        d.color = p.Colour;
                        d.party = p.Name
                        newData.push(d);
                    } else {
                        const newSegment = {
                            ...d,
                            x: new Date(p.DateStart).valueOf() > d.x ? new Date(p.DateStart).valueOf() : d.x,
                            x2: p.DateEnd && new Date(p.DateEnd).valueOf() < d.x2 ? new Date(p.DateEnd).valueOf() : d.x2, 
                            color: p.Colour,
                            party: p.Name
                        };
                        newData.push(newSegment);
                    }
                });
            }
        });
        return newData;
}

const formatMinistries = (data, y) => 
    data
        .map(p => ({
            id: p.Id,
            name: p.MinistryName,
            color: p.colour,
            party: null,
            leaderPhid: p.LeaderPHID,
            partyList: p.Parties,
            x: new Date(p.DateStart).valueOf(),
            present: p.DateEnd === null,
            x2: p.DateEnd ? new Date(p.DateEnd).valueOf() : new Date().valueOf(),
            y,
            dataLabels: {
                format: '<a href="/Ministry/{point.id}" class="timeline-label">{point.name}</a>',
            }
        }));

export default {
    created() {
        this.initialiseData();
    },
    components: {
        StatisticalHeader,
        Timeline,
        Loader
    },
    methods: {
        initialiseData() {
            this.loading = true;
            let endpoints = [
                'api/StatisticalInformation/PrimeMinisters',
                'api/StatisticalInformation/LeadersOfTheOpposition',
                'api/StatisticalInformation/Speakers',
                'api/StatisticalInformation/Presidents',
                'api/StatisticalInformation/Ministries'
            ]
            axios.all(endpoints.map((endpoint) => axios.get(endpoint))).then(
                axios.spread(({data: primeMinisters}, 
                    {data: leadersOfTheOpposition},
                    {data: speakers},
                    {data: presidents},
                    {data: ministries}) => {
                    this.primeMinisters = primeMinisters;
                    this.leadersOfTheOpposition = leadersOfTheOpposition;
                    this.speakers = speakers;
                    this.presidents = presidents;
                    this.ministries = ministries;
                    this.loading = false;
                })
            );
        }
    },
    computed: {
        chartData() {
            // need refactor
            const formattedItems = [...this.primeMinisters].map(item => {
                // need to assign 
                const newData = [];
                item.PeriodOfService.forEach(d => {
                    // find party
                    if (item.Party.length === 1) {
                        // d.PartyColour = item.Party[0].Colour;
                        // d.PartyName = item.Party[0].Name
                        newData.push({
                            ...d,
                            PartyColour: item.Party[0].Colour,
                            PartyName: item.Party[0].Name,
                            TotalDays: Math.floor(((d.DateEnd ? new Date(d.DateEnd) : new Date()) - new Date(d.DateStart)) / 86400000)
                        });
                    } else {
                        // need to break record up into segments
                        // for each party
                        // find matching parties
                        item.Party.filter(p => (new Date(p.DateStart) <= new Date(d.DateEnd) && new Date(p.DateEnd) >= new Date(d.DateStart))).forEach(p => {
                            // find fully matching segment
                            if (new Date(d.DateStart) >= new Date(p.DateStart).valueOf() && new Date(d.DateEnd) <= new Date(p.DateEnd)) {
                                // d.PartyColour = p.Colour;
                                // d.PartyName = p.Name
                                newData.push({
                                    ...d,
                                    PartyColour: p.Colour,
                                    PartyName: p.Name,
                                    TotalDays: Math.floor(((d.DateEnd ? new Date(d.DateEnd) : new Date()) - new Date(d.DateStart)) / 86400000)
                                });
                            } else {
                                const newSegment = {
                                    ...d,
                                    DateStart: new Date(p.DateStart) >= new Date(d.DateStart) ? p.DateStart : d.DateStart,
                                    DateEnd: p.DateEnd && new Date(p.DateEnd) <= new Date(d.DateEnd) ? p.DateEnd : d.DateEnd, 
                                    PartyColour: p.Colour,
                                    PartyName: p.Name,
                                };
                                newSegment.TotalDays = Math.floor(((newSegment.DateEnd ? new Date(newSegment.DateEnd) : new Date()) - new Date(newSegment.DateStart)) / 86400000)
                                newData.push(newSegment);
                            }
                        });
                    }
                });

                return {
                    ...item,
                    PeriodOfService: newData,
                }
            });

            const primeMinisters = formattedItems.flatMap(p => p.PeriodOfService);
            // add colours to ministries based on PMs
            const ministries = this.ministries.map(m => {
                // find a term based on ministry start date
                let colour = ''
                let pm = primeMinisters.find(p => new Date(p.DateStart) <= new Date(m.DateStart) && new Date(p.DateEnd).addDays(1) >= new Date(m.DateEnd));
                if (pm) {
                    colour = pm.PartyColour
                }
                else {
                    pm = primeMinisters.find(p => p.DateStart === m.DateStart);
                    if (pm) {
                        colour = pm.PartyColour
                        // colour = 'pink'
                    }
                }
                return {...m, colour};
            });

            return {
                chart: {
                    height: 9000,
                    type: 'xrange',
                    inverted: true,
                   
                    events: {
                        render: function () {
                            const chart = this
                            let {min: currentMin, max: currentMax} = chart.yAxis[0].getExtremes()
                            if (chart.chartWidth < 500 && currentMax - currentMin > 1) {
                                chart.yAxis[0].setExtremes(0, 0)
                            }
                            else if (chart.chartWidth < 500 && chart.previousWidth !== chart.chartWidth || (chart.min !== currentMin && chart.max !== currentMax )) {
                                chart.previousWidth = chart.chartWidth
                                chart.min = chart.yAxis[0].getExtremes().min;
                                chart.max = chart.yAxis[0].getExtremes().max;

                                const moveLeft = () => {
                                    let {min, max, dataMin} = chart.yAxis[0].getExtremes()
                                    if (min - 1 >= dataMin) {
                                        min -= 1
                                        max -= 1
                                    }
                                    chart.yAxis[0].setExtremes(min, max)
                                }
                                const moveRight = () => {
                                    let {min, max, dataMax} = chart.yAxis[0].getExtremes()
                                    if (max + 1 <= dataMax) {
                                        min += 1
                                        max += 1
                                    }
                                    chart.yAxis[0].setExtremes(min, max)
                                }
                                if (chart.leftArrow) {
                                    chart.leftArrow.destroy();
                                    chart.leftArrow = null;
                                }
                                if (chart.rightArrow) {
                                    chart.rightArrow.destroy();
                                    chart.rightArrow = null;
                                }
                                const renderArrows = () => {
                                    let {min, max, dataMax, dataMin} = chart.yAxis[0].getExtremes()
                                    const leftArrowUrl = 'https://cdn-icons-png.flaticon.com/512/271/271220.png'
                                    const rightArrowUrl = 'https://cdn-icons-png.flaticon.com/512/271/271228.png'
                                    const leftArrowX = chart.chartWidth - 20;
                                    if (min - 1 >= dataMin) {
                                        const leftArrow = chart.renderer.image(leftArrowUrl, 0, 5, 20, 20).attr({ zIndex: 10 })
                                        chart.leftArrow = leftArrow.on('click', moveLeft).add()
                                    }
                                    if (max + 1 <= dataMax) {
                                        const rightArrow = chart.renderer.image(rightArrowUrl, leftArrowX, 5, 20, 20).attr({ zIndex: 10 })
                                        chart.rightArrow = rightArrow.on('click', moveRight).add()
                                    }
                                }
                                renderArrows();
                            } else if (chart.previousWidth != chart.chartWidth) {
                                chart.previousWidth = chart.chartWidth;
                                if (chart.leftArrow) {
                                    chart.leftArrow.destroy();
                                    chart.leftArrow = null;
                                }
                                if (chart.rightArrow) {
                                    chart.rightArrow.destroy();
                                    chart.rightArrow = null;
                                }
                                const { dataMin, dataMax } = chart.yAxis[0].getExtremes()
                                chart.yAxis[0].setExtremes(dataMin, dataMax);
                            }
                        }                    
                    }
                },
                 tooltip: {
                        borderWidth: 0,
                        backgroundColor: 'transparent',
                        shadow: false,
                        useHTML: true,
                        followPointer: true,
                        formatter: function () {
                            var todaysDate = new Date();
                            // console.log(this.point)
                            var dateIsToday = new Date(this.x2).setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0);
                            var showEndDate = dateIsToday ? 'present' : new Date(this.x2).toLocaleDateString('en-AU');

                            var partyStrings = this.point.partyList != null ? this.point.partyList.map(p => {
                                let partyString = `<div>
                                    <span tabindex="-1" class="v-chip v-chip--disabled v-chip--small">
                                        <span class="v-chip__content">
                                            <div class="v-avatar" style="height: 48px; width: 48px; background-color: ${p.Colour}; border-color: ${p.Colour};">
                                                <span style="color: ${ (p.Colour == null || p.Colour.toLowerCase() != '#bfff00' ? '#fff' : '#000')} ;">${p.Count}</span>
                                            </div>
                                            <span style="white-space: break-spaces">${p.Name}</span>
                                        </span>
                                    </span>
                                </div>`;

                                return partyString;
                            }).join(' ') : '';

                            var tooltipMarkup = '<div class="tooltip" style="width:300px;min-height: 100px;">'
                            + '<div style="display:inline-block;"><img src="https://www.aph.gov.au/api/parliamentarian/' 
                            + (this.point.phid != null ? this.point.phid : this.point.leaderPhid)
                            + '/image" style="width: 80px;border-radius: 5px;" /></div><div style="vertical-align: top;display:inline-block; width:200px; padding-left:10px;">' 
                            + '<p style="font-size:1.1em;font-weight:bold;white-space: normal;">' + this.point.yCategory + '</p>' 
                            + '<p style="font-size:1.1em;white-space: normal;">' + this.point.name + '</p>' 
                            +  (this.point.phid != null ?  '<p style="white-space: normal; margin-bottom:0.2rem;">' + this.point.party + '</p>' : '')
                            + '<p style="white-space: normal; margin-bottom:0.2rem;">' + new Date(this.x).toLocaleDateString('en-AU') + ' - ' + showEndDate + '</p>'
                            + '</div>'
                            + (this.point.phid == null ? '<p style="font-size:0.95em; margin-bottom:0rem;font-weight:bold;white-space: normal;">Ministers:</p>'  : '')
                            + (this.point.phid == null ? partyStrings : '')
                            + '</div>';
                            return tooltipMarkup;
                        }, 
                    },
                series: [
                    {
                        pointWidth: 30,
                        data: [
                            ...formatLeaders(this.primeMinisters, 0),
                            ...formatMinistries(ministries, 1),
                            ...formatLeaders(this.leadersOfTheOpposition, 2),
                            ...formatLeaders(this.speakers, 3),
                            ...formatLeaders(this.presidents, 4)
                            ],
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            crop: false
                        }
                    },
                ],
                exporting: {
                    enabled: false,
                    sourceWidth: 2000
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    categories: [
                    'Prime Ministers',
                    'Ministries',
                    'Leaders of the Opposition', 
                    'Speakers of the House of Representatives', 
                    'Presidents of the Senate'
                    ],
                    labels: {
                        y: -8930
                    }
                },
            }
        }
    },
    data() {
        return {
            title: 'Parliamentary timeline',
            primeMinisters: [],
            leadersOfTheOpposition: [],
            speakers: [],
            ministries: [],
            loading: true
        }
    }
}
</script>
<style>
.timeline-label-parl :hover {
    
}

</style>
<style lang="stylus" scoped>

    #timeline >>> div {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-container svg {
        overflow: visible !important;
    }

    #timeline >>> .highcharts-tooltip span {
        background-color: transparent;
    }

    #timeline >>> .highcharts-yaxis-labels text {
        cursor: pointer !important;
    }

    #timeline >>> .timeline-label {
        text-decoration: none; color: black;
    }

    #timeline >>> .timeline-label-parl {
        text-decoration: none; color: black; display: flex; align-items: center;
    }

    #timeline >>> .timeline-label-parl:hover {
        text-decoration: underline;
    }

</style>